import React from 'react';

const DateRangeFilter = ({ startDate, endDate, onStartDateChange, onEndDateChange, onChange }) => {
  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    onStartDateChange(newStartDate);
    onChange?.({ startDate: newStartDate, endDate });
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    onEndDateChange(newEndDate);
    onChange?.({ startDate, endDate: newEndDate });
  };

  return (
    <div className="flex gap-2">
      <div className="flex-1">
        <input
          type="date"
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          value={startDate}
          onChange={handleStartDateChange}
        />
      </div>
      <div className="flex-1">
        <input
          type="date"
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          value={endDate}
          onChange={handleEndDateChange}
        />
      </div>
    </div>
  );
};

export default DateRangeFilter; 